function heightMatch() {
	$('.m__filter-module .filter-item .filter-item__inner .button').matchHeight();
	$('.m__filter-module .filter-item .filter-item__inner .venue-name').matchHeight();
	$('.m__icons .m__icons-icon h2').matchHeight();
	$('.m__icons .m__icons-icon .m__icons-icon-content').matchHeight();
	$('.m__link-images .il-item .il-item__inner p').matchHeight();
	$('#page__front-page .hh__cols .hh__col-content h2').matchHeight();
	$('#page__front-page .hh__cols .hh__col-content p').matchHeight();
}